<app-modal [modalConfig]="modalConfig">
    <div class="section-container" *ngIf="!isLoading">
        <div class="header-section" *ngIf="reportData && reportData.data.length > 0">
            <button class="filter-button" (click)="toggleFilters()" [ngClass]="{'active':enableFilters}">
                <fa-icon [icon]="faFilter" class="filter-icon"></fa-icon>
                <span>Filtrar Búsqueda</span>
            </button>
        </div>
        <section class="section-content">
            <ng-container *ngIf="reportData && reportData.data.length > 0">
                <div class="table-container">
                    <app-table [headers]="tableData.headers" tableLabel="Task Report data Table"
                        [enableFilters]="enableFilters" (searchEvent)="filterByColumn($event)"
                        (sortEvent)="orderData($event)">
                        <tr tableBody *ngFor="let row of tableData.data">
                            <td *ngFor="let header of tableData.headers">
                                {{row[header.key]}}
                            </td>
                        </tr>
                    </app-table>
                </div>
                <app-paginator [actualPage]="actualPage" [hidden]="tableData.data.length === 0" [quantity]="quantity"
                    [maxQuantity]="maxQuantity" [maxSize]="7" (changePageEvent)="changePage($event)">
                </app-paginator>
            </ng-container>
            <div [hidden]="reportData && reportData.data.length > 0" class="empty-list">
                ¡No se encontraron datos de la tarea en ejecución {{ reportTask.nombre}}!
            </div>
        </section>
    </div>
    <div class="loader" [hidden]="!isLoading">
        <ngx-ui-loader loaderId="report-data" [hasProgressBar]="false"></ngx-ui-loader>
    </div>
</app-modal>